import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCommonPodDataByTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';
interface IProps {
  psaId: number;
  ticketId: string;
}

export const ThunkGetCommonPodDataByTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getCommonPodDataByTicketId',
  async ({ psaId, ticketId }) => getCommonPodDataByTicketId(psaId, ticketId).then(r => r.data),
);
